<template>
  <div>
    <div class="view-order">
      <div class="bread">
        <router-link class="bread-item" to="/">上上签</router-link>
        <div class="bread-arrow">&gt;</div>
        <router-link class="bread-item" to="/orders">订单管理</router-link>
        <div class="bread-arrow">&gt;</div>
        <router-link class="bread-item" :to="'/orders/detail/'+oid">订单详情</router-link>
      </div>

      <div class="order-main" v-if="product">
        <div class="visa-img">
          <img :src="product.visa_page" @click="previewImage" />
        </div>
        <div class="content">
          <div class="title">请对照上方签证示例图，仔细核对每一项信息:</div>
          <div v-if="tips.length" class="tips">
            <div v-for="(tip,index) in tips" :key="index">{{tip}}</div>
          </div>
          <div class="tips" v-else>若签证信息出错，将会导致无法入境，请务必仔细核对每一项信息。若发现问题，请尽早联系客服。</div>
          <div class="check-box">
            <div class="check-button" @click="checkHandle" v-if="order && order.order_status == 8">核对完毕</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Http from '@/libs/http';
import orderingService from '../../../services/ordering-service';

export default {
  data() {
    return {
      order: undefined,
      product: undefined,
      oid: this.$route.params.oid ? +this.$route.params.oid : undefined,
    };
  },
  created() {
    this.init();
  },
  computed: {
    tips() {
      return this.product && this.product.visa_check_desc ? this.product.visa_check_desc.split('\n') : [];
    },
  },
  methods: {
    async init() {
      await this.getOrderDetail();
      await this.getProductDetail();
    },
    // 订单获取
    getOrderDetail() {
      if (!this.oid) return;
      return Http.post('/order_query', { user_order_id: this.oid }).then((data) => {
        this.order = data;
      }).catch((e) => {
        if (e) console.log(e);
      });
    },
    // 获取商品信息
    getProductDetail() {
      if (!this.order || !this.order.visa_product_id) return;
      return orderingService.getProductData(this.order.visa_product_id).then((data) => {
        this.product = data;
      }).catch((e) => {
        if (e) console.log(e);
      });
    },
    previewImage() {
      if (!this.product.visa_page) return;
      this.$viewerApi({
        images: [this.product.visa_page],
      });
    },
    async checkHandle() {
      await this.$confirm('确定后核对签证信息内容将不再展示，确定信息准确无误吗？', '重要提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      });
      if (!this.oid) return;
      Http.post('/order_visa_check', { user_order_id: this.oid }).then(() => {
        this.$router.back();
      }).catch((e) => {
        if (e) console.log(e);
      });
    },
  },
};

</script>

<style lang="less" scoped>
.view-order {
  width: 920px;
  margin: auto;
  padding-bottom: 100px;
  .hierarchy {
    line-height: 56px;
  }

  .order-main {
    background: #FFFFFF;
    border-radius: 4px;
    padding: 60px 188px 80px 188px;
    .visa-img {
      img {
        width: 100%;
      }
    }
    .content {
      margin-top: 24px;
      title {
        font-weight: 600;
        font-size: 16px;
        color: #2F333D;
        line-height: 28px;
      }
      .tips {
        margin-top: 8px;
        font-size: 14px;
        color: #91999F;
        line-height: 1.5em;
      }
      .check-box {
        text-align: center;
        margin-top: 24px;
        .check-button {
          display: inline-block;
          background: #599FFF;
          border-radius: 4px;
          padding: 9px 56px;
          color: #fff;
          font-size: 16px;
          cursor: pointer;
        }
      }
      
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/orders/page-check/page-check.vue